/** SPEC-TIER Part C — tier option model for the admin tier control. */
export const TIER_VALUES = ["default", "extended", "longterm", "unlimited"] as const;
export type TierValue = (typeof TIER_VALUES)[number];

/** i18n key for a tier label, e.g. admin.tier.option.default */
export function tierLabelKey(tier: string): string {
  return `admin.tier.option.${tier}`;
}

/**
 * Which tiers an admin may assign to a target with the given role.
 * 'unlimited' is admin-only (the DB enforces this; the UI hides it for
 * non-admin targets so a rejected option is never shown).
 */
export function assignableTiers(targetRole: string): TierValue[] {
  return targetRole === "admin"
    ? ["default", "extended", "longterm", "unlimited"]
    : ["default", "extended", "longterm"];
}
